import { Amplify } from 'aws-amplify';
import { amplifyConfig } from '../config/env';

// Configure AWS Amplify
Amplify.configure(amplifyConfig);

export default Amplify;